import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";

const ClientsReviewCreate = () => {
  const { clientsReviewApi } = apiPath;
  const { clientsReview } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "textField",
      label: "Review Title",
      type: "Text",
      name: "title",
      required: true,
    },
    {
      elementType: "textField",
      label: "Review",
      type: "Text",
      name: "message",
      required: true,
    },
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      name: "img",
      required: true,
    },
    {
      elementType: "textField",
      label: "Client Name",
      type: "Text",
      name: "name",
      required: false,
    },
    {
      elementType: "input",
      label: "Designation",
      type: "Text",
      name: "designation",
      required: true,
    },
    {
      elementType: "select",
      label: "Featured",
      type: "Text",
      name: "featured",
      required: true,
      options: ["true", "false"],
      //.filter((item) => item !== featured)
    },
  ];

  const update = (data) => {
    updateData(clientsReviewApi, data, false, null, null, true);
    setTimeout(() => {
      navigate("/" + clientsReview);
    }, 1000);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ClientsReviewCreate;
